/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BranchGroupListResponse } from '../../models/branch-group-list-response';

export interface GetBranchGroups$Params {
}

export function getBranchGroups(http: HttpClient, rootUrl: string, params?: GetBranchGroups$Params, context?: HttpContext): Observable<StrictHttpResponse<BranchGroupListResponse>> {
  const rb = new RequestBuilder(rootUrl, getBranchGroups.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BranchGroupListResponse>;
    })
  );
}

getBranchGroups.PATH = '/api/v1/branches/groups';
